export default "/images/save.svg?7594d350dc632274f80b9aae9e3c07f0";